<template>
  <div class="d-flex flex-wrap align-items-center flex-row-reverse">
    <div
      class="ml-4 mt-3"
    >
      <a
        :href="csvUrl"
        :download="csvFilename"
      >
        <button class="btn btn-light">
          <font-awesome-icon icon="download" />
          Download CSV
        </button>
      </a>
      <button
        v-if="pdfBtn"
        class="btn btn-light"
        @click="openPrint()"
      >
        <font-awesome-icon icon="download" />
        Save as PDF
      </button>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    csvFilename: {
      type: String,
      required: true,
    },
    csvUrl: {
      type: String,
      required: true,
    },
    pdfBtn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openPrint () {
      window.print()
    },
  },
}
</script>
